import clsx from "clsx";
import { FC, PropsWithChildren } from "react";

export const BaseFooter: FC<PropsWithChildren<{ darkMode?: boolean; isMobile?: boolean }>> = ({
  children,
  darkMode,
  isMobile,
}) => {
  return (
    <footer
      className={clsx(
        "group/themable relative flex w-full items-center rounded-b-none rounded-t-lg border-t border-t-black-tint-90 bg-white text-sm shadow-md data-[dark]:border-t-black-tint-15 data-[dark]:bg-black-tint-15",
        isMobile ? "h-[--footer-height-mobile] px-6 pb-6 pt-3" : "h-[--footer-height] p-3",
      )}
      data-dark={darkMode || undefined}
    >
      {children}
    </footer>
  );
};
